import { OpenAttestationEthereumTokenRegistryStatusCode, CodedError, ValidTokenRegistryStatus } from '@tradetrust-tt/tt-verify';
import * as w3cVC from '@trustvc/w3c-vc';
import { isTokenMintedOnRegistry } from './utils';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const TRANSFERABLE_RECORDS_TYPE = "TransferableRecords";
const type = "DOCUMENT_STATUS";
const name = TRANSFERABLE_RECORDS_TYPE;
const verify = /* @__PURE__ */ __name(async (document, options) => {
  const signedDocument = document;
  const credentialStatuses = Array.isArray(signedDocument?.credentialStatus) ? signedDocument?.credentialStatus : [signedDocument?.credentialStatus];
  const { provider } = options;
  const verificationResult = await Promise.all(
    credentialStatuses.map(async (credentialStatus) => {
      const tokenId = "0x" + credentialStatus.tokenId;
      if (!credentialStatus?.tokenRegistry) {
        throw new CodedError(
          "Document's credentialStatus does not have tokenRegistry",
          OpenAttestationEthereumTokenRegistryStatusCode.UNRECOGNIZED_DOCUMENT,
          OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.UNRECOGNIZED_DOCUMENT]
        );
      }
      if (!credentialStatus?.tokenNetwork || !credentialStatus?.tokenNetwork?.chainId) {
        throw new CodedError(
          "Document's credentialStatus does not have tokenNetwork.chainId",
          OpenAttestationEthereumTokenRegistryStatusCode.UNRECOGNIZED_DOCUMENT,
          OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.UNRECOGNIZED_DOCUMENT]
        );
      }
      const mintStatus = await isTokenMintedOnRegistry({
        tokenRegistryAddress: credentialStatus?.tokenRegistry,
        tokenId,
        provider
      });
      return mintStatus;
    })
  );
  const result = {
    name,
    type,
    status: "INVALID",
    data: {
      tokenRegistry: credentialStatuses?.[0]?.tokenRegistry
    }
  };
  if (verificationResult.every(ValidTokenRegistryStatus.guard)) {
    result.status = "VALID";
  } else {
    result.reason = verificationResult?.[0]?.reason;
  }
  return result;
}, "verify");
const skip = /* @__PURE__ */ __name(async () => {
  return {
    status: "SKIPPED",
    type,
    name,
    reason: {
      code: OpenAttestationEthereumTokenRegistryStatusCode.SKIPPED,
      codeString: OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.SKIPPED],
      message: `Document does not have TransferableRecords status`
    }
  };
}, "skip");
const test = /* @__PURE__ */ __name((document) => {
  const doc = document;
  const credentialStatuses = Array.isArray(doc?.credentialStatus) ? doc?.credentialStatus : [doc?.credentialStatus];
  if (w3cVC.isSignedDocument(document) && credentialStatuses.every((cs) => cs?.type === TRANSFERABLE_RECORDS_TYPE)) {
    return true;
  }
  return false;
}, "test");
const credentialStatusTransferableRecordVerifier = {
  skip,
  test,
  verify: /* @__PURE__ */ __name(async (...args) => {
    try {
      return await verify(...args);
    } catch (e) {
      if (e instanceof CodedError) {
        const err = {
          name,
          type,
          status: "ERROR",
          reason: {
            code: e.code,
            codeString: e.codeString,
            message: e.message
          }
        };
        return err;
      }
      return {
        name,
        type,
        status: "ERROR",
        reason: {
          code: OpenAttestationEthereumTokenRegistryStatusCode.UNEXPECTED_ERROR,
          codeString: OpenAttestationEthereumTokenRegistryStatusCode[OpenAttestationEthereumTokenRegistryStatusCode.UNEXPECTED_ERROR],
          message: e instanceof Error ? e.message : "An unexpected error occurred"
        }
      };
    }
  }, "verify")
};

export { TRANSFERABLE_RECORDS_TYPE, credentialStatusTransferableRecordVerifier };
